import React, { useEffect, useState } from 'react';
import '../ProductStatusFilter.css';
import { Button, CircularProgress, IconButton, Tooltip } from '@material-ui/core';

function RefreshOrderFilter({ refreshData }) {
    const [isRefreshLoading, setIsRefreshLoading] = useState(false);


    const handleRefreshBtn = () => {
        setIsRefreshLoading(true);
        refreshData();
        setIsRefreshLoading(false);
    }

    return (
        <>
            <div className="allProducts__productStatusFilter">
                <div className={`allProducts__productStatusContent allProducts__flexContent ml-5`}>
                    <Button
                        variant="contained" 
                        className={`employerGreen__createProduct`}
                        onClick={handleRefreshBtn}>
                            {isRefreshLoading ? <CircularProgress size={16} /> : "Refresh"}
                        </Button>
                </div>
            </div>
        </>
    )
}

export default RefreshOrderFilter
